module.exports = __webpack_public_path__ + "img/banner07.6b5781c3.png";